import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errorText } from "../lib/api";

// Handles `#session_id=…` after Google sign-in: exchanges it server-side, then returns to the board.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", location.pathname);
        navigate(location.pathname || "/", { replace: true, state: { user: r.data } });
      } catch (e) {
        setError(errorText(e));
      }
    })();
  }, [location.hash, location.pathname, navigate]);

  if (!error) return null;
  return (
    <div className="min-h-screen flex items-center justify-center bg-page p-6" data-testid="auth-callback-error">
      <div className="panel max-w-sm w-full p-6 text-center">
        <p className="text-sm text-brand font-semibold">{error}</p>
        <button
          type="button"
          data-testid="auth-callback-back"
          onClick={() => {
            window.history.replaceState(null, "", "/");
            navigate("/", { replace: true });
          }}
          className="mt-4 rounded-full bg-ink text-white px-5 py-2 text-sm font-semibold"
        >
          Back to sign in
        </button>
      </div>
    </div>
  );
}
